export const handleBrowserClass = () => {
    const userAgent = navigator.userAgent;
    const browserPatterns = [
        { name: "chrome", regex: /Chrome\/(\d+)\./ },
        { name: "safari", regex: /Version\/(\d+)\.\d+.*Safari/ },
        { name: "safari", regex: /iPhone OS (\d+)_/ }, // Older versions of Safari
    ];

    let browser: string | null = null;
    let version: string | null = null;

    for (const { name, regex } of browserPatterns) {
        const match = userAgent.match(regex);
        if (match) {
            browser = name;
            version = match[1] ?? null;
            break;
        }
    }

    if (browser && version) {
        document.body.classList.add(`${browser}-${version}`);
    }
};
